/* Scrub the existing CSS loop directly, preserving its position and speed. */
(()=>{
 const reduced=matchMedia('(prefers-reduced-motion: reduce)');
 const initialize=(scope=document)=>scope.querySelectorAll('.m24-area-row').forEach(row=>{
  if(row.dataset.dragReady)return;row.dataset.dragReady='true';
  const track=row.querySelector('.m24-area-track');let gesture=null;
  const shift=dx=>{
   if(reduced.matches){row.scrollLeft-=dx;return}
   const animation=track.getAnimations()[0],width=track.querySelector('.m24-area-group').getBoundingClientRect().width;
   if(!animation||!width)return;
   const duration=Number(animation.effect.getTiming().duration);
   const sign=getComputedStyle(track).animationDirection==='reverse'?1:-1;
   const time=Number(animation.currentTime)||0;
   animation.currentTime=((time+dx/sign/width*duration)%duration+duration)%duration;
  };
  const stop=()=>{
   if(!gesture)return;
   const id=gesture.id;gesture=null;row.classList.remove('m24-area-dragging');track.style.animationPlayState='';
   if(row.hasPointerCapture(id))row.releasePointerCapture(id);
  };
  row.addEventListener('pointerdown',event=>{
   if(!event.isPrimary||event.button!==0)return;
   if(reduced.matches&&event.pointerType==='touch')return;
   gesture={id:event.pointerId,x:event.clientX};
   track.style.animationPlayState='paused';row.classList.add('m24-area-dragging');
   row.setPointerCapture(event.pointerId);
   if(event.pointerType==='mouse')event.preventDefault();
  });
  row.addEventListener('pointermove',event=>{
   if(!gesture||gesture.id!==event.pointerId)return;
   shift(event.clientX-gesture.x);gesture.x=event.clientX;
  });
  row.addEventListener('pointerup',stop);row.addEventListener('pointercancel',stop);row.addEventListener('lostpointercapture',stop);
  row.addEventListener('keydown',event=>{
   if(!['ArrowLeft','ArrowRight'].includes(event.key))return;
   event.preventDefault();shift(event.key==='ArrowLeft'?150:-150);
  });
  reduced.addEventListener('change',stop);
 });
 initialize();document.addEventListener('shopify:section:load',event=>initialize(event.target));
})();
